<div class="dialog-title confirm-title">
  @if (data.icon) {
    <span class="material-symbols-outlined icon" [class.danger]="danger">{{ data.icon }}</span>
  }
  {{ data.title }}
</div>

<div class="dialog-content">
  <p class="message">{{ data.message }}</p>
  @if (data.details?.length) {
    <dl class="details">
      @for (d of data.details; track d.label) {
        <dt>{{ d.label }}</dt>
        <dd>{{ d.value || '-' }}</dd>
      }
    </dl>
  }
</div>

<div class="dialog-actions">
  <button type="button" class="btn btn-text" (click)="cancel()">{{ data.cancelText ?? 'Cancel' }}</button>
  <button type="button" class="btn" [class.btn-danger]="danger" [class.btn-primary]="!danger" (click)="confirm()">
    {{ data.confirmText ?? 'Confirm' }}
  </button>
</div>
